// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__vsPSL","accordionItem":"styles_accordionItem__w3HOD","header":"styles_header__M6Q5v","body":"styles_body__qJu3e"};